import React, { useState } from 'react';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import localization from 'assets/localization/localization';
import Regex from 'services/utils/regex/Regex';
import DatePicker from 'components/sales/datePicker/datePicker';

const SiteFilterFormForEngg = ({
  applyFilter,
  siteTypes = [],
  assignedAreas = [],
  reportees = [],
  child = [],
  siteStatus = [],
  city = [],
  showCommercialFilter = false
}) => {
  const filterInputs = {
    site_no: '',
    client_name: '',
    site_type: '',
    area_id: '',
    reportee: '',
    reportingTo: '',
    status_id: '',
    city_id:'',
    commercial_type_id:'',
    to_date:'',
    from_date:''
  };

  const [filterFieldsData, setFilterFieldsData] = useState(filterInputs);
  console.log('Filter::Engineer');
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        applyFilter(filterFieldsData);
      }}
    >
      <ConstantInput
        label={localization.siteNumber}
        value={filterFieldsData.site_no}
        regex={Regex.number.test(filterFieldsData.site_no)}
        type="text"
        handleChange={(val) =>
          setFilterFieldsData({ ...filterFieldsData, site_no: val })
        }
      />
      <ConstantInput
        label={localization.clientName}
        value={filterFieldsData.client_name}
        regex={Regex.text.test(filterFieldsData.client_name)}
        type="text"
        handleChange={(val) =>
          setFilterFieldsData({ ...filterFieldsData, client_name: val })
        }
      />
    {/* {siteTypes.length !== 0 ? 
    
    <DropDownInput
        disabled={siteTypes.length === 0}
        label={localization.siteType}
        data={siteTypes}
        getIdValue={(val) =>
          setFilterFieldsData({ ...filterFieldsData, site_type: val.id })
        }
      />
    : ''} */}
      {/* {siteStatus.length !== 0 ? 
      <DropDownInput
      disabled={siteStatus.length === 0}
      label={localization.siteStatus}
      data={siteStatus}
      getIdValue={(val) =>
        setFilterFieldsData({ ...filterFieldsData, status_id: val.id })
      }
    />
      : ''} */}
      
      {/* {assignedAreas.length !== 0 ? 
      <DropDownInput
      dishowCommercialFiltersabled={assignedAreas.length === 0}
      label={localization.assignedArea}
      data={assignedAreas}
      getIdValue={(val) =>
        setFilterFieldsData({ ...filterFieldsData, area_id: val.id })
      }
    />
      : ''} */}
       {city.length !== 0 ? 
      <DropDownInput
      disabled={city.length === 0}
      label={localization.city}
      data={city}
      getIdValue={(val) =>
        setFilterFieldsData({ ...filterFieldsData, city_id: val.id })
      }
    />
      : ''}
      {/* {reportees.length !== 0 ? <DropDownInput
        disabled={reportees.length === 0}
        label={localization.reportingTo}
        data={reportees}
        getIdValue={(val) =>
          setFilterFieldsData({ ...filterFieldsData, reportingTo: val.id })
        }
      /> : ''} */}

       {/* {child.length !== 0 ? <DropDownInput
        disabled={child.length === 0}
        label={localization.reportee}
        data={child}
        getIdValue={(val) =>
          setFilterFieldsData({ ...filterFieldsData, reportee: val.id })
        }
      /> : ''} */}

      {/* {showCommercialFilter && <DropDownInput
          label={localization.commercialType}
          data={[
            {id: 5, name: "Capex",},
            {id: 6, name: "Opex-Ownership",},
            {id: 7, name: "Rental",},
          ]}
          getIdValue={(val) =>{
            setFilterFieldsData({
              ...filterFieldsData,
              commercial_type_id: val.id,
            })
          }
          }
      />} */}
      {/* <DatePicker
        handleChange={(val) =>
          setFilterFieldsData({ ...filterFieldsData, from_date: val })
        }
        label={`From Date`}
        required={false}
      />
      <DatePicker
          handleChange={(val) =>
            setFilterFieldsData({ ...filterFieldsData, to_date: val })
          }
          label={`To Date`}
          required={false}
      /> */}
      
      <br />
      <br />
      <br />
      <div className="btn-wrapper">
        <button disabled={false} type="submit" className="btn btn-primary">
          {localization.applyFilter}
          <img src="../images/arrow-right.png" alt="" />
        </button>
        <br />
        <br />
        <button
          onClick={() => {
            applyFilter(filterInputs);
          }}
          type="button"
          className="btn btn-primary"
        >
          {localization.removeFilter}
        </button>
      </div>
    </form>
  );
};

export default SiteFilterFormForEngg;
